import { FC } from "react";
import BackgroundSVGs from "../../auth/layout/BackgroundSVGs";
import { useNavigate } from "react-router-dom";
import { Button, theme } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../../services/store/slices/cart";
import queryClient from "../../../services/react-query/queryClient";
import { setCurrentLang } from "../../../services/store/slices/user";
import { primaryLanguagesChanger } from "../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";

interface HeaderProps {}

const Header: FC<HeaderProps> = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentLang = useSelector((state: any) => state?.user?.currentLang);

  const { client } = useSelector(
    (state: {
      cart: {
        client: {
          phoneNumber: string | null;
          token: string | null;
        };
      };
    }) => {
      return {
        client: state.cart.client,
      };
    }
  );
  const url = window.location.href;
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };
  const navigationCards = () => {
    if (
      url.includes("appointment") ||
      url.includes("gift-card") ||
      url.includes("membership")
    ) {
      return false;
    }
    return true;
  };
  const { useToken } = theme;
  const { token } = useToken() as any;
  const handelChangeLng = () => {
    dispatch(setCurrentLang(currentLang === "ar" ? "en" : "ar"));
    document
      .getElementsByTagName("html")[0]
      .setAttribute("lang", currentLang === "ar" ? "en" : "ar");
    localStorage.setItem("currentLang", currentLang === "ar" ? "en" : "ar");
    setTimeout(() => {
      // queryClient.clear();
      queryClient.invalidateQueries();
      // window.location.reload();
    }, 500);
  };

  let docStyle = getComputedStyle(document.documentElement);

  let iconColor = docStyle.getPropertyValue("--salon-secondary");
  return (
    <div
      className="relative flex justify-center items-end w-full h-[200px] bg-color-primary rounded-b-xl"
      style={{ backgroundColor: token?.colorPrimary } as any}
    >
      <div className="container w-full overflow-hidden flex justify-center gap-[160px]">
        <div className="flex justify-center gap-8 opacity-20">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="79"
            height="49"
            viewBox="0 0 79 49"
            fill="none"
          >
            <path
              d="M69.7024 39.398L78.5 30.0989L67.581 18.5509C70.914 13.0052 72.6819 6.57004 72.6774 0L60.3251 0C60.2303 5.6816 58.0285 11.0966 54.1937 15.0792C50.3589 19.0617 45.1978 21.2933 39.8217 21.2933C34.4456 21.2933 29.2846 19.0617 25.4498 15.0792C21.615 11.0966 19.4131 5.6816 19.3184 0L7.01699 0C7.00807 5.83837 8.39986 11.5838 11.0622 16.6992L0.5 27.8634L9.30399 37.1624L19.0572 26.8601C23.2712 30.513 28.2811 32.9965 33.6328 34.0852V49H46.0743V34.0852C50.7678 33.1331 55.2064 31.1034 59.0765 28.1395L69.7024 39.398Z"
              fill="#EEF0FF"
            />
            <path
              d="M69.7024 39.398L78.5 30.0989L67.581 18.5509C70.914 13.0052 72.6819 6.57004 72.6774 0L60.3251 0C60.2303 5.6816 58.0285 11.0966 54.1937 15.0792C50.3589 19.0617 45.1978 21.2933 39.8217 21.2933C34.4456 21.2933 29.2846 19.0617 25.4498 15.0792C21.615 11.0966 19.4131 5.6816 19.3184 0L7.01699 0C7.00807 5.83837 8.39986 11.5838 11.0622 16.6992L0.5 27.8634L9.30399 37.1624L19.0572 26.8601C23.2712 30.513 28.2811 32.9965 33.6328 34.0852V49H46.0743V34.0852C50.7678 33.1331 55.2064 31.1034 59.0765 28.1395L69.7024 39.398Z"
              stroke="#7FE1C2"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="55"
            height="49"
            viewBox="0 0 55 49"
            fill="none"
          >
            <path
              d="M54.3332 48.9794C50.6343 48.9794 38.1082 48.5839 26.6244 43.6428C19.4232 46.4935 10.8223 48.3169 1.45897 48.964L0.5 38.5939C5.4262 38.272 10.2995 37.5042 15.0394 36.3031C13.3191 34.7065 11.8052 32.9533 10.5245 31.0744C8.67612 28.3604 7.22749 25.4583 6.21211 22.4352C3.59133 14.3558 6.13468 9.25036 8.73163 6.38945C12.222 2.54752 18.0414 0.22594 24.7005 0.0153525C31.8839 -0.210644 38.7098 2.06985 42.9626 6.10182C50.4021 13.1642 47.8408 23.1234 47.2512 25.0495C45.8084 29.516 42.9372 33.5422 38.9659 36.6678C44.0038 37.9086 49.2131 38.5565 54.4523 38.5939L54.5 49L54.3332 48.9794ZM25.6595 10.3855H25.1413C22.1631 10.4779 19.4828 11.4127 18.232 12.7738C15.8137 15.4396 17.8508 21.2333 20.9421 25.7943C22.4969 28.0529 24.5437 30.0308 26.9699 31.6188C31.4729 29.0199 34.5165 25.8559 35.5827 22.3735C35.5827 22.37 35.5888 22.3463 35.5997 22.3043C35.776 21.6214 37.2039 16.0909 34.0281 13.0718C32.2829 11.4179 29.0427 10.3855 25.6595 10.3855Z"
              fill="#EEF0FF"
            />
            <path
              d="M54.3332 48.9794C50.6343 48.9794 38.1082 48.5839 26.6244 43.6428C19.4232 46.4935 10.8223 48.3169 1.45897 48.964L0.5 38.5939C5.4262 38.272 10.2995 37.5042 15.0394 36.3031C13.3191 34.7065 11.8052 32.9533 10.5245 31.0744C8.67612 28.3604 7.22749 25.4583 6.21211 22.4352C3.59133 14.3558 6.13468 9.25036 8.73163 6.38945C12.222 2.54752 18.0414 0.22594 24.7005 0.0153525C31.8839 -0.210644 38.7098 2.06985 42.9626 6.10182C50.4021 13.1642 47.8408 23.1234 47.2512 25.0495C45.8084 29.516 42.9372 33.5422 38.9659 36.6678C44.0038 37.9086 49.2131 38.5565 54.4523 38.5939L54.5 49L54.3332 48.9794ZM25.6595 10.3855H25.1413C22.1631 10.4779 19.4828 11.4127 18.232 12.7738C15.8137 15.4396 17.8508 21.2333 20.9421 25.7943C22.4969 28.0529 24.5437 30.0308 26.9699 31.6188C31.4729 29.0199 34.5165 25.8559 35.5827 22.3735C35.5827 22.37 35.5888 22.3463 35.5997 22.3043C35.776 21.6214 37.2039 16.0909 34.0281 13.0718C32.2829 11.4179 29.0427 10.3855 25.6595 10.3855Z"
              stroke="#00086D"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="59"
            height="49"
            viewBox="0 0 59 49"
            fill="none"
          >
            <path
              d="M53.8694 4.42078C50.9054 1.59315 46.8857 0.00467455 42.6945 0.00467455C38.5033 0.00467455 34.4837 1.59315 31.5197 4.42078L29.4971 6.35081L27.4746 4.4157C24.5114 1.58838 20.4927 0 16.3023 0C12.112 0 8.09325 1.58838 5.13011 4.4157C3.66223 5.81586 2.49779 7.47824 1.70335 9.30793C0.908904 11.1376 0.5 13.0987 0.5 15.0792C0.5 17.0598 0.908904 19.0209 1.70335 20.8506C2.49779 22.6803 3.66223 24.3427 5.13011 25.7428L7.15265 27.6728L29.5024 49L51.8522 27.6728L53.8801 25.7428C56.8403 22.9132 58.502 19.0779 58.5 15.0797C58.498 11.0815 56.8324 7.24765 53.8694 4.42078Z"
              fill="#EEF0FF"
            />
            <path
              d="M53.8694 4.42078C50.9054 1.59315 46.8857 0.00467455 42.6945 0.00467455C38.5033 0.00467455 34.4837 1.59315 31.5197 4.42078L29.4971 6.35081L27.4746 4.4157C24.5114 1.58838 20.4927 0 16.3023 0C12.112 0 8.09325 1.58838 5.13011 4.4157C3.66223 5.81586 2.49779 7.47824 1.70335 9.30793C0.908904 11.1376 0.5 13.0987 0.5 15.0792C0.5 17.0598 0.908904 19.0209 1.70335 20.8506C2.49779 22.6803 3.66223 24.3427 5.13011 25.7428L7.15265 27.6728L29.5024 49L51.8522 27.6728L53.8801 25.7428C56.8403 22.9132 58.502 19.0779 58.5 15.0797C58.498 11.0815 56.8324 7.24765 53.8694 4.42078Z"
              stroke="#75C81B"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="61"
            height="49"
            viewBox="0 0 61 49"
            fill="none"
          >
            <path
              d="M20.9048 48.9952L16.0705 47.3569L16.798 35.683L2.50061 36.2817L0.5 32.3345L11.1366 24.4976L0.511745 16.6655L2.51232 12.7135L16.8098 13.3122L16.0823 1.63828L20.9165 0L30.4971 8.68003L40.0952 0L44.9294 1.63828L44.1961 13.3122L58.4994 12.7135L60.5 16.6655L49.8576 24.4976L60.4824 32.3298L58.4994 36.2817L44.1961 35.6878L44.9294 47.3617L40.0952 49L30.4971 40.3152L20.9048 48.9952Z"
              fill="#EEF0FF"
            />
            <path
              d="M20.9048 48.9952L16.0705 47.3569L16.798 35.683L2.50061 36.2817L0.5 32.3345L11.1366 24.4976L0.511745 16.6655L2.51232 12.7135L16.8098 13.3122L16.0823 1.63828L20.9165 0L30.4971 8.68003L40.0952 0L44.9294 1.63828L44.1961 13.3122L58.4994 12.7135L60.5 16.6655L49.8576 24.4976L60.4824 32.3298L58.4994 36.2817L44.1961 35.6878L44.9294 47.3617L40.0952 49L30.4971 40.3152L20.9048 48.9952Z"
              stroke="#5F72FF"
            />
          </svg>
        </div>
        <div className="flex justify-center gap-8 opacity-20">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="55"
            height="49"
            viewBox="0 0 55 49"
            fill="none"
          >
            <path
              d="M54.3332 48.9794C50.6343 48.9794 38.1082 48.5839 26.6244 43.6428C19.4232 46.4935 10.8223 48.3169 1.45897 48.964L0.5 38.5939C5.4262 38.272 10.2995 37.5042 15.0394 36.3031C13.3191 34.7065 11.8052 32.9533 10.5245 31.0744C8.67612 28.3604 7.22749 25.4583 6.21211 22.4352C3.59133 14.3558 6.13468 9.25036 8.73163 6.38945C12.222 2.54752 18.0414 0.22594 24.7005 0.0153525C31.8839 -0.210644 38.7098 2.06985 42.9626 6.10182C50.4021 13.1642 47.8408 23.1234 47.2512 25.0495C45.8084 29.516 42.9372 33.5422 38.9659 36.6678C44.0038 37.9086 49.2131 38.5565 54.4523 38.5939L54.5 49L54.3332 48.9794ZM25.6595 10.3855H25.1413C22.1631 10.4779 19.4828 11.4127 18.232 12.7738C15.8137 15.4396 17.8508 21.2333 20.9421 25.7943C22.4969 28.0529 24.5437 30.0308 26.9699 31.6188C31.4729 29.0199 34.5165 25.8559 35.5827 22.3735C35.5827 22.37 35.5888 22.3463 35.5997 22.3043C35.776 21.6214 37.2039 16.0909 34.0281 13.0718C32.2829 11.4179 29.0427 10.3855 25.6595 10.3855Z"
              fill="#EEF0FF"
            />
            <path
              d="M54.3332 48.9794C50.6343 48.9794 38.1082 48.5839 26.6244 43.6428C19.4232 46.4935 10.8223 48.3169 1.45897 48.964L0.5 38.5939C5.4262 38.272 10.2995 37.5042 15.0394 36.3031C13.3191 34.7065 11.8052 32.9533 10.5245 31.0744C8.67612 28.3604 7.22749 25.4583 6.21211 22.4352C3.59133 14.3558 6.13468 9.25036 8.73163 6.38945C12.222 2.54752 18.0414 0.22594 24.7005 0.0153525C31.8839 -0.210644 38.7098 2.06985 42.9626 6.10182C50.4021 13.1642 47.8408 23.1234 47.2512 25.0495C45.8084 29.516 42.9372 33.5422 38.9659 36.6678C44.0038 37.9086 49.2131 38.5565 54.4523 38.5939L54.5 49L54.3332 48.9794ZM25.6595 10.3855H25.1413C22.1631 10.4779 19.4828 11.4127 18.232 12.7738C15.8137 15.4396 17.8508 21.2333 20.9421 25.7943C22.4969 28.0529 24.5437 30.0308 26.9699 31.6188C31.4729 29.0199 34.5165 25.8559 35.5827 22.3735C35.5827 22.37 35.5888 22.3463 35.5997 22.3043C35.776 21.6214 37.2039 16.0909 34.0281 13.0718C32.2829 11.4179 29.0427 10.3855 25.6595 10.3855Z"
              stroke="#00086D"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="78"
            height="49"
            viewBox="0 0 78 49"
            fill="none"
          >
            <path
              d="M68.8152 39.398L77.5 30.0989L66.721 18.5509C70.0113 13.0052 71.7565 6.57004 71.7521 0L59.5581 0C59.4645 5.6816 57.291 11.0966 53.5053 15.0792C49.7197 19.0617 44.6247 21.2933 39.3176 21.2933C34.0104 21.2933 28.9155 19.0617 25.1299 15.0792C21.3442 11.0966 19.1706 5.6816 19.0771 0L6.93344 0C6.92464 5.83837 8.29858 11.5838 10.9268 16.6992L0.5 27.8634L9.19112 37.1624L18.8193 26.8601C22.9792 30.513 27.925 32.9965 33.208 34.0852V49H45.49V34.0852C50.1234 33.1331 54.505 31.1034 58.3255 28.1395L68.8152 39.398Z"
              fill="#EEF0FF"
            />
            <path
              d="M68.8152 39.398L77.5 30.0989L66.721 18.5509C70.0113 13.0052 71.7565 6.57004 71.7521 0L59.5581 0C59.4645 5.6816 57.291 11.0966 53.5053 15.0792C49.7197 19.0617 44.6247 21.2933 39.3176 21.2933C34.0104 21.2933 28.9155 19.0617 25.1299 15.0792C21.3442 11.0966 19.1706 5.6816 19.0771 0L6.93344 0C6.92464 5.83837 8.29858 11.5838 10.9268 16.6992L0.5 27.8634L9.19112 37.1624L18.8193 26.8601C22.9792 30.513 27.925 32.9965 33.208 34.0852V49H45.49V34.0852C50.1234 33.1331 54.505 31.1034 58.3255 28.1395L68.8152 39.398Z"
              stroke="#7FE1C2"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="59"
            height="49"
            viewBox="0 0 59 49"
            fill="none"
          >
            <path
              d="M53.8694 4.42078C50.9054 1.59315 46.8857 0.00467455 42.6945 0.00467455C38.5033 0.00467455 34.4837 1.59315 31.5197 4.42078L29.4971 6.35081L27.4746 4.4157C24.5114 1.58838 20.4927 0 16.3023 0C12.112 0 8.09325 1.58838 5.13011 4.4157C3.66223 5.81586 2.49779 7.47824 1.70335 9.30793C0.908904 11.1376 0.5 13.0987 0.5 15.0792C0.5 17.0598 0.908904 19.0209 1.70335 20.8506C2.49779 22.6803 3.66223 24.3427 5.13011 25.7428L7.15265 27.6728L29.5024 49L51.8522 27.6728L53.8801 25.7428C56.8403 22.9132 58.502 19.0779 58.5 15.0797C58.498 11.0815 56.8324 7.24765 53.8694 4.42078Z"
              fill="#EEF0FF"
            />
            <path
              d="M53.8694 4.42078C50.9054 1.59315 46.8857 0.00467455 42.6945 0.00467455C38.5033 0.00467455 34.4837 1.59315 31.5197 4.42078L29.4971 6.35081L27.4746 4.4157C24.5114 1.58838 20.4927 0 16.3023 0C12.112 0 8.09325 1.58838 5.13011 4.4157C3.66223 5.81586 2.49779 7.47824 1.70335 9.30793C0.908904 11.1376 0.5 13.0987 0.5 15.0792C0.5 17.0598 0.908904 19.0209 1.70335 20.8506C2.49779 22.6803 3.66223 24.3427 5.13011 25.7428L7.15265 27.6728L29.5024 49L51.8522 27.6728L53.8801 25.7428C56.8403 22.9132 58.502 19.0779 58.5 15.0797C58.498 11.0815 56.8324 7.24765 53.8694 4.42078Z"
              stroke="#75C81B"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="63"
            height="49"
            viewBox="0 0 63 49"
            fill="none"
          >
            <path
              d="M21.585 48.9952L16.5896 47.3569L17.3413 35.683L2.56729 36.2817L0.5 32.3345L11.4911 24.4976L0.512137 16.6655L2.57939 12.7135L17.3534 13.3122L16.6017 1.63828L21.5971 0L31.497 8.68003L41.415 0L46.4104 1.63828L45.6526 13.3122L60.4327 12.7135L62.5 16.6655L51.5028 24.4976L62.4818 32.3298L60.4327 36.2817L45.6526 35.6878L46.4104 47.3617L41.415 49L31.497 40.3152L21.585 48.9952Z"
              fill="#EEF0FF"
            />
            <path
              d="M21.585 48.9952L16.5896 47.3569L17.3413 35.683L2.56729 36.2817L0.5 32.3345L11.4911 24.4976L0.512137 16.6655L2.57939 12.7135L17.3534 13.3122L16.6017 1.63828L21.5971 0L31.497 8.68003L41.415 0L46.4104 1.63828L45.6526 13.3122L60.4327 12.7135L62.5 16.6655L51.5028 24.4976L62.4818 32.3298L60.4327 36.2817L45.6526 35.6878L46.4104 47.3617L41.415 49L31.497 40.3152L21.585 48.9952Z"
              stroke="#5F72FF"
            />
          </svg>
        </div>
      </div>
      <div className="absolute max-sm:top-0 sm:bottom-0 -end-0  sm:end-1.5 !z-50 flex gap-2 items center">
        <div>
          <Button
            className="header-lang-btn !text-salon-secondary  hover:!text-salon-secondary "
            onClick={handelChangeLng}
            icon={primaryLanguagesChanger(iconColor)}
          >
            {currentLang === "ar" ? "English" : "العربية"}
          </Button>
        </div>
        {client && client?.token ? (
          <Button
            type="link"
            onClick={() => {
              dispatch(clearCart());
            }}
          >
            <span className="text-salon-secondary">
              {intl.formatMessage({ id: "logout" })}
            </span>
          </Button>
        ) : null}
      </div>

      {!navigationCards() ? (
        <div className="absolute max-sm:top-0 sm:bottom-0 -start-0  sm:start-1.5 !z-50 ">
          <Button
            type="link"
            className="!text-salon-secondary flex items-center gap-1"
            onClick={goBack}
          >
            <span className="-translate-y-[2px]">&lt;</span>
            <span>{intl.formatMessage({ id: "back" })}</span>
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default Header;
